// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1MvEb","label":"Category_label__1B-xi","content":"Category_content__18BT6","header":"Category_header__rT8NA","location":"Category_location__3N5JP"};